module.exports = __webpack_public_path__ + "static/media/300_13.cc2a7932.jpg";